import { isAfter } from 'date-fns';
import jwtDecode from 'jwt-decode';
import { LocalStorageKey, DecodedTokenShape } from '../types';
import { jsonParseOrStringify } from './localStorage';

export const setToken = (token: string) => {
  if (window?.localStorage) {
    localStorage.setItem('accessToken', token);
  }
};
export const getToken = () => localStorage.getItem('accessToken');
export const removeToken = () => localStorage.removeItem('accessToken');
export const checkSignedIn = () => {
  const token = getToken();
  if (!token) {
    return false;
  }

  try {
    const decoded = decodeAuthToken(token);

    return decoded ? isAfter(decoded.exp * 1000, new Date()) : false;
  } catch (e) {
    removeToken();

    return false;
  }
};
export const getAuthHeaders = () => {
  const token = getToken();

  const authHeaders = new Headers();
  authHeaders.append('Authorization', `${token}`);

  return authHeaders;
};
export const decodeAuthToken = (token?: string | null) => {
  let decoded: DecodedTokenShape | null = null;

  if (!token) {
    return null;
  }

  try {
    decoded = jwtDecode<DecodedTokenShape>(token);
  } catch (e) {
    console.error('Invalid token provided', e);
  }

  return decoded;
};

export function manageLocalStorage(method: 'set' | 'get', key: LocalStorageKey, value?: string): any;
export function manageLocalStorage(
  method: 'set_json' | 'get_json',
  key: LocalStorageKey,
  value?: Record<string, any>
): any;
export function manageLocalStorage(method: 'remove', key: LocalStorageKey): any;

export function manageLocalStorage(
  method: 'set' | 'set_json' | 'get' | 'get_json' | 'remove',
  key: LocalStorageKey,
  value?: unknown
) {
  try {
    switch (method) {
      case 'set':
        localStorage.setItem(key, (value as string) || '');
        return undefined;
      case 'set_json':
        localStorage.setItem(key, jsonParseOrStringify('stringify', { params: value as Record<string, any> }));
        return undefined;
      case 'get':
        return localStorage.getItem(key);
      case 'get_json':
        return jsonParseOrStringify('parse', { stringifiedData: localStorage.getItem(key) });
      case 'remove':
        localStorage.removeItem(key);
        return undefined;
      default:
        return undefined;
    }
  } catch (error) {
    console.error(error);

    return undefined;
  }
}
